import { FC, ReactNode } from "react";

type Props = {
  title: string;
};
export const SubscriberDetailsDetail: FC<Props> = ({ title, children }) => {
  return (
    <div className='flex flex-col'>
      <dt className='text-base text-black'>{title}</dt>
      <dd className='bg-gray-50 rounded p-2 text-lg border'>{children}</dd>
    </div>
  );
};
